import React, { Fragment } from "react";
import { List, ListItemIcon, ListItemText, Divider, ListItemButton, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import IconComponent from "../../../components/ui/IconComponent";
import { useTranslation } from "react-i18next";

interface MenuItem {
  to: string;
  icon: React.ReactNode;
  primary: string;
  secondary?: string;
  disabled?: boolean;
}

const ProfileMenuList = () => {
  const { t } = useTranslation("profile");
  const theme = useTheme();

  const menuItems: MenuItem[] = [
    {
      to: "/profile/appearence",
      icon: <IconComponent iconName={"Half"} size={19} hasStroke />,
      primary: t("appearance"),
      disabled: false,
    },
    {
      to: "/profile/timezone",
      icon: <IconComponent iconName={"Clock"} hasStroke hasFill />,
      primary: t("timezone"),
      secondary: t("system"),
      disabled: true,
    },
    {
      to: "/profile/currency",
      icon: <IconComponent iconName={"Coins"} hasStroke hasFill />,
      primary: t("currency"),
      secondary: "USD, $",
      disabled: true,
    },
    {
      to: "/profile/language",
      icon: <IconComponent iconName={"Globe"} size={19} hasFill={true} hasStroke={true} />,
      primary: t("language"),
      secondary: "English",
      disabled: false,
    },
    {
      to: "/profile/notifications",
      icon: <IconComponent iconName={"BELL"} size={19} hasStroke={true} hasFill={true} />,
      primary: t("notifications"),
      disabled: false,
    },
    {
      to: "/profile/about",
      icon: <IconComponent iconName={"InfoIcon"} size={19} hasFill={true} hasStroke={true} />,
      primary: t("about"),
      disabled: false,
    },
  ];

  const listItemClassList = `adron-list-theme ${theme.palette.mode === "dark" ? "dark" : "light"}`;

  return (
    <>
      <Stack
        sx={{
          backgroundColor: theme.palette.secondary.main,
          borderRadius: "12px",
          marginBottom: 3,
        }}
      >
        <ListItemButton
          sx={{
            borderRadius: "12px",
            display: "flex",
            justifyContent: "space-between",
            gap: "8px",
            maxHeight: "40px",
            color: theme.myTheme.colors.foreground100,
          }}
          component={Link}
          to={"/profile/account"}
        >
          <ListItemIcon sx={{ minWidth: "auto" }}>
            <IconComponent size={18} iconName={"Wallet"} hasStroke={true} hasFill={true} />
          </ListItemIcon>

          <ListItemText primary={t("accountCenter")} />

          <ListItemIcon sx={{ minWidth: "auto" }}>
            <IconComponent size={18} iconName={"ChevronRight"} hasStroke={true} />
          </ListItemIcon>
        </ListItemButton>
      </Stack>

      <List
        className={listItemClassList}
        sx={{
          backgroundColor: theme.palette.grey[400],
          borderRadius: "12px",
          paddingTop: 0,
          paddingBottom: 0,
        }}
      >
        {menuItems.map((item, index) => (
          <Fragment key={index}>
            <ListItemButton
              sx={{
                borderRadius: "12px",
                display: "flex",
                justifyContent: "space-between",
                gap: "8px",
              }}
              disabled={item.disabled}
              component={Link}
              to={item.to}
            >
              <ListItemIcon sx={{ minWidth: "auto" }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.primary} secondary={item.secondary} />
              <ListItemIcon sx={{ minWidth: "auto" }}>
                <IconComponent iconName={"ChevronRight"} hasStroke={true} />
              </ListItemIcon>
            </ListItemButton>

            {index < menuItems.length - 1 && (
              <Divider sx={{ borderColor: theme.palette.background.default }} />
            )}
          </Fragment>
        ))}
      </List>

      <Stack sx={{ backgroundColor: theme.palette.grey[400], marginTop: 3, borderRadius: "12px" }}>
        <ListItemButton
          sx={{
            borderRadius: "12px",
            display: "flex",
            justifyContent: "space-between",
            gap: "8px",
            height: "40px",
          }}
          className={listItemClassList}
          component={Link}
          to={"/profile/support"}
          disabled={true}
        >
          <ListItemIcon sx={{ minWidth: "auto" }}>
            <IconComponent iconName={"Question"} hasStroke size={18} />
          </ListItemIcon>
          <ListItemText primary={t("support")} />
          <ListItemIcon sx={{ minWidth: "auto" }}>
            <IconComponent size={18} iconName={"ChevronRight"} hasStroke={true} />
          </ListItemIcon>
        </ListItemButton>
      </Stack>
    </>
  );
};

export default ProfileMenuList;
